import { Box } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";

const SummaryDataGrid = (props) => {
    const [data, setData] = useState([]);

    const csv = props.csv;
    const filter = props.filter;
    const { readString } = usePapaParse();

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                results.data.map((d, idx) => { d.id = idx });
                setData(results.data.filter(d => d['Food commodity'] === filter));
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, [filter]);

    const cols = [
        { field: 'Pesticide', headerName: 'Pesticide', flex: 1, minWidth: 100 },
        { field: 'EU status', headerName: 'EU status', flex: 1, minWidth: 100 },
        { field: 'Total number of results', headerName: 'Total no. of results', type: "number", flex: 1, minWidth: 100 },
        { field: 'Flag. Above Legal Limit result ID_sum', headerName: 'MRL exceedances', type: "number", flex: 1, minWidth: 100 },
        { field: 'Flag. non Compliant PEST result ID_sum', headerName: 'Non-compliant', type: "number", flex: 1, minWidth: 100 },
        { field: 'Number of countries', headerName: 'Countries analysed', type: "number", flex: 1, minWidth: 100 },
        { field: 'Coverage', headerName: 'Coverage', flex: 1, minWidth: 100 },
    ]

    return (
        <Box sx={{ height: 350, marginBottom: '4rem' }}>
            <p style={{ marginBottom: '.5rem' }}>{props.title}</p>
            <DataGrid columns={cols} rows={data} components={{
                Toolbar: GridToolbar,
            }} />
        </Box>
    );

}

export default SummaryDataGrid;